<template>
  <div>
    <hr>
    <h4>user Functions</h4>
    moment.tz.guess(): {{timezone_guess}}
    <br />
    user_get_timezone: {{ user_get_timezone }} (selectedTZ: {{selectedTZ}})
    <br />
    user_get_UTCtimestamp(): {{ user_get_UTCtimestamp }}
    <br />
    user_get_local_datetime(): {{ user_get_local_datetime() }}
    <br />
    user_get_local_datetime('hh:mm'): {{ user_get_local_datetime('hh:mm') }}
    <br />
    user_get_time_difference_browsertime_to_UTC_in_minutes: {{ user_get_time_difference_browsertime_to_UTC_in_minutes }}
    <br />
    user_get_time_difference_usertime_to_UTC_in_minutes: {{ user_get_time_difference_usertime_to_UTC_in_minutes }}
    <br />
    user_get_UTC_time_for_local_time(value1): {{ ( value1 && value1.constructor.name === 'Moment') ? user_get_UTC_time_for_local_time(value1) : 'N/A' }}
    <br />
    user_get_UTC_time(value1): {{ ( value1 && value1.constructor.name === 'Moment') ? user_get_UTC_time(value1) : 'N/A' }}

    <hr>
    <h4>Picker</h4>

    <h6>el-date-picker (Does not support custom timezones!)</h6>
    <el-date-picker
      editable
      v-model="value1"
      type="datetime"
      placeholder="End">
    </el-date-picker>
    <pre>{{value1}}</pre><br />

    <h6>date-selector (supports custom timezones, uses selectedTZ!)</h6>
    <date-selector
      v-model="value2"
      type="datetime"
      placeholder="First day"
      disable-before="today"
      :userTimezone="selectedTZ"
      :showTimezoneTooltip="true" />
    <pre>{{value2}}</pre><br />

    <h6>date-selector-inline (supports custom timezones)</h6>
    <date-selector-inline
      v-model="value3"
      type="datetime"
      placeholder="deadline"
      text_if_empty="forever" />
    <pre>{{value3}}</pre><br />

    <el-button @click="setValues(1)">Set Value 1: new Date()</el-button><br>
    <el-button @click="setValues(2)">Set Value 2: moment()</el-button><br>
    <el-button @click="setValues(3)">Set Value 3: '2018-05-12T17:33Z';</el-button><br>
    <el-button @click="setValues(4)">Set Value 4: '2018-05-12T12:33-05:00';</el-button><br>
    <el-button @click="setValues(5)">Set Value 5: moment().unix() * 1000; </el-button><br>
    <el-button @click="setValues(6)">Set Value 6: moment('2018-05-12T17:33Z')</el-button><br>
    <el-button @click="setValues(7)">Set Value 7: moment('2018-05-12T12:33-05:00')</el-button><br>
    <el-button @click="setValues(8)">Set Value 8: moment.tz('2018-05-12T17:33Z', 'America/New_York')</el-button><br>
    <el-button @click="setValues(9)">Set Value 9: moment.tz('2018-05-12T17:33Z', 'Europe/Berlin')</el-button><br>
    <el-button @click="setValues(10)">Set Value 10: moment.tz(1544203980 => Fri Dec 07 2018 12:33:00 GMT-0500, 'America/New_York')</el-button><br>
    <el-button @click="setValues(11)">Set Value 11: moment.tz(1544203980 => Fri Dec 07 2018 12:33:00 GMT-0500, 'Europe/Berlin')</el-button><br>
    <el-button @click="setValues(12)">Set Value 12: moment.tz(1544203980 => Fri Dec 07 2018 12:33:00 GMT-0500, '{{selectedTZ}}')</el-button><br>
    <el-button @click="setValues(20)">Set Value 20: firebase.firestore.Timestamp.fromDate( new Date() )</el-button><br>
    <pre>{{(value1 && value1.format) ? value1.format() : 'N/A'}}</pre>

    <hr>
    <h4>User Timezone</h4>
    <el-select
      v-model="selectedTZ"
      filterable
      reserve-keyword>
      <el-option
        v-for="item in timezones"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-button @click="writeTimezoneToDB">Write Timezone to DB</el-button>
    <pre>Selected Timezone: {{selectedTZ}}, User Timezone (Database): {{user_get_timezone}}</pre>

    <hr>
    <el-button @click="addEvent()" type="danger">Add event at value2 = {{value2}}</el-button>
    <br>
    <br>
    <full-calendar
      ref="calendar"
      :events="calendar_testdata"
      :config="{}"
      :editable="true"
      :selectable="true"
      @event-selected="onEventSelect"
      @event-resize="onEventResize"
      @event-drop="onEventResize"
      @event-created="onEventCreate">
      ></full-calendar>
    <!--
    fullcalendar timezone support is pretty useless
    <el-button @click="onChangeTimezone">Update fullcalendar Timezone to {{selectedTZ}}</el-button>
    -->

    <pre>calendar_testdata: {{calendar_testdata}}</pre>
    <pre>additional_data: {{additional_data}}</pre>
  </div>
</template>

<script>
import moment from '@/moment-gp.js'
import $ from 'jquery'
import firebase from "@firebase/app";
import { mapGetters } from 'vuex'
import DateSelector from '@/components/Elements/DateSelector'
import DateSelectorInline from '@/components/Elements/DateSelectorInline'
import { FullCalendar } from 'vue-full-calendar'

export default {
  data: () => ({
    selectedTZ: 'UTC',
    timezones: [],
    value1: null,
    value2: null,
    value3: null,
    additional_data: []
  }),
  mounted() {
    $.getJSON('https://fullcalendar.io/demo-timezones.json', (timezones) => {
      this.timezones = [];
      this.timezones.push({ value: null, label: 'null' });
      timezones.forEach(timezone => {
        // UTC is already in the list
        // if (timezone === 'UTC') { return }
        this.timezones.push({ value: timezone, label: timezone });
      });
    });

    this.additional_data.push({
      title:     'test pre',
      userStart: moment().unix(),
      userEnd:   moment().unix() + 60 * 60
    });
  },
  watch: {
    selectedTZ: (tz) => {
      console.log('Setting moment default to', tz);
      moment.tz.setDefault(tz);
      // ^ This is not the best idea
    }
  },
  computed: {
    user_get_timezone() {
      return this.$models.userSettings.getters.user_get_timezone;
    },

    ...mapGetters("user", [
      "user_get_UTCtimestamp",
      "user_get_local_datetime",
      "user_get_time_difference_browsertime_to_UTC_in_minutes",
      "user_get_time_difference_usertime_to_UTC_in_minutes",
      "user_get_UTC_time_for_local_time",
      "user_get_UTC_time",
      "user_get_UTC_time_for_browser_time"
    ]),

    calendar_testdata() {
      // let userStart = moment('2018-12-08T18:00Z').unix();
      // let userEnd = moment('2018-12-08T20:00Z').unix();

      let data = [...this.additional_data];
      // let tz = this.user_get_timezone;

      return data.map((event, idx) => {
        return {
          id:     idx,
          title:  event.title,
          start:  event.userStart.toFullCalendarV3(),
          end:    event.userEnd.toFullCalendarV3(),
        };
      })
    },

    timezone_guess() {
      return moment.tz.guess();
    }
  },
  methods: {

    setValues(action) {
      let value;
      switch (action) {
        case 1: value = new Date(); break;
        case 2: value = moment(); break;
        case 3: value = '2018-12-07T17:33Z'; break;
        case 4: value = '2018-12-07T12:33-05:00'; break;
        case 5: value = moment().unix() * 1000; break;
        case 6: value = moment('2018-12-07T17:33Z'); break;
        case 7: value = moment('2018-12-07T12:33-05:00'); break;
        case 8: value = moment.tz('2018-12-07T17:33Z', 'America/New_York'); break;
        case 9: value = moment.tz('2018-12-07T17:33Z', 'Europe/Berlin'); break;
        case 10: value = moment.tz(1544203980 * 1000, 'America/New_York'); break;
        case 11: value = moment.tz(1544203980 * 1000, 'Europe/Berlin'); break;
        // 1544203980 => Fri Dec 07 2018 12:33:00 GMT-0500
        case 12: value = moment.tz(1544203980 * 1000, this.selectedTZ); break;
        case 20: value = firebase.firestore.Timestamp.fromDate( new Date() ); break;
      }

      this.value1 = value;
      this.value2 = value;
      this.value3 = value;
    },

    onEventSelect(e) {
      console.log("onEventSelect", e);

      // let tz = this.user_get_timezone;
      let start = moment.fromFullCalendarV3( e.start )
      let end = moment.fromFullCalendarV3( e.end )

      console.log("start", start.format());
      console.log("end", end.format());
    },

    onEventResize(e) {
      console.log("onEventResize", e);

      // let tz = this.user_get_timezone;
      let start = moment.fromFullCalendarV3( e.start )
      let end = moment.fromFullCalendarV3( e.end )

      let idx = this.calendar_testdata.findIndex(item => item.id === e.id); // HACK
      if ( idx !== -1 ) {
        // Fake a database write by converting to a unix timestamp
        this.additional_data[ idx ].userStart = start.unix();
        this.additional_data[ idx ].userEnd = end.unix();
      }
    },

    onEventCreate(e) {
      console.log("onEventCreate", e);

      $(this.$refs.calendar.$el).fullCalendar('unselect');

      // let tz = this.user_get_timezone;
      let start = moment.fromFullCalendarV3( e.start )
      let end = moment.fromFullCalendarV3( e.end )

      console.log("start", start.format());

      // Fake a database write by converting to a unix timestamp
      this.additional_data.push({
        title:     'test',
        userStart: start.unix(),
        userEnd:   end.unix(),
      })
    },

    onChangeTimezone() {
      /* This is pretty useless, even in V4 */
      let tz = this.selectedTZ;
      console.log('Updating timezone option fullcalendar to', tz);
      let calendarElement = $(this.$refs.calendar.$el);
      calendarElement.fullCalendar('option', 'timezone', tz || false);
    },

    addEvent() {
      let start = this.value2;
      this.additional_data.push({
        title:     'test',
        userStart: start.unix(),
        userEnd:   start.unix() + 60 * 60,
      })
    },

    writeTimezoneToDB() {
      let updatedUserData = {
        'settings.timezone': this.selectedTZ,
      }
      this.$api.user_update_settings(updatedUserData).then(() => {
        console.log("Timezone sucessfully written");
        // TODO: Force calendar refresh!
        // TODO: This is required anyways after page changes
      }).catch(() => {
        console.log("Timezone not written");
      });
    }
  },
  components: {
    DateSelector,
    DateSelectorInline,
    FullCalendar
  }
}
</script>
